import { stages } from '../content/stages';
import type { SaveData, Stage } from '../types';

export const pad = (value: number): string => String(value).padStart(2, '0');

export function localDate(date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(date);
  const value = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${value.year}-${value.month}-${value.day}`;
}

export function addDays(dateKey: string, amount: number): string {
  const [year, month, day] = dateKey.split('-').map(Number);
  const value = new Date(Date.UTC(year, month - 1, day + amount));
  return `${value.getUTCFullYear()}-${pad(value.getUTCMonth() + 1)}-${pad(value.getUTCDate())}`;
}

export function daysBetween(from: string, to: string): number {
  const parse = (key: string): number => {
    const [year, month, day] = key.split('-').map(Number);
    return Date.UTC(year, month - 1, day) / 86_400_000;
  };
  return parse(to) - parse(from);
}

export function confirmedDate(save: SaveData, now = new Date()): string {
  const current = localDate(now);
  return current < save.lastConfirmedDate ? save.lastConfirmedDate : current;
}

const schedule = ['SD01', 'SD02', 'SD04', 'SD05', 'SD09', 'SD06', 'SD10', 'SD03', 'SD07', 'SD11', 'SD08', 'SD12', 'SD14', 'SD13', 'SD15', 'SD18', 'SD16', 'SD19', 'SD17', 'SD20'];

function stableHash(value: string): number {
  let hash = 2166136261;
  for (const char of value) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
  return hash >>> 0;
}

export function stageForDate(dateKey: string, save?: SaveData): Stage {
  if (save && dateKey === save.installDate && Object.keys(save.clears).length === 0) {
    return stages[stableHash(save.installId) % 3];
  }
  const epoch = daysBetween('2026-07-21', dateKey);
  const id = schedule[((epoch % schedule.length) + schedule.length) % schedule.length];
  return stages.find((stage) => stage.id === id) ?? stages[0];
}

export function recentDates(today: string): string[] {
  return Array.from({ length: 7 }, (_, index) => addDays(today, index - 6));
}
